// extracted by mini-css-extract-plugin
var _1 = "K3a5BLSl24bsiu5Tyqex";
var _2 = "TVnp38Z9auAn_im5WTpR";
var _3 = "tnNS6uaAX2eBPUcCLkMG";
var _4 = "OPtLp77LI9_Gp8Jr9Vyn";
var _5 = "U9C24lDTYR7zM_jVU6zA";
export { _1 as "btn", _2 as "btn__active", _3 as "desc", _4 as "ico", _5 as "ico_wrap" }
